import { render, staticRenderFns } from "./EditAd.vue?vue&type=template&id=671ef940&scoped=true&"
import script from "./EditAd.vue?vue&type=script&lang=ts&"
export * from "./EditAd.vue?vue&type=script&lang=ts&"
import style0 from "./EditAd.vue?vue&type=style&index=0&id=671ef940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ef940",
  null
  
)

export default component.exports